var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLbLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.917969,
    width: 26.1635,
    height: 26.1635,
    rx: 6.65563,
    fill: "#DCFAD2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17366_221862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4417 10.1628C10.4693 10.1508 10.497 10.1391 10.5247 10.1278L16.891 7.14284L22.4494 10.5481L21.4709 17.0183L10.6043 22.1133L8.96759 18.584L8.701 18.0487C6.73844 17.6802 4.57568 16.6219 1.93335 14.178L6.0174 12.2497C5.56527 10.2743 6.04996 8.16285 7.39272 6.57271L8.31917 5.47559L10.4417 10.1628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7932 11.8741C16.5857 12.5482 16.9605 13.265 17.6303 13.475C18.3002 13.6851 19.0113 13.3089 19.2188 12.6348C19.4263 11.9607 19.0515 11.244 18.3817 11.0339C17.7119 10.8238 17.0007 11.2 16.7932 11.8741ZM18.4313 12.2848C18.4374 12.2925 18.4431 12.3003 18.4486 12.3083C18.4738 12.0971 18.3466 11.8914 18.1379 11.8259C17.903 11.7522 17.6533 11.8841 17.5804 12.121C17.53 12.2846 17.5773 12.4553 17.6889 12.5694C17.6821 12.4386 17.736 12.3064 17.8455 12.2184C18.0255 12.0737 18.2878 12.1034 18.4313 12.2848Z",
    fill: "#00322E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.39267 6.57173L8.31911 5.47461L10.4417 10.1619C10.469 10.15 10.4964 10.1384 10.5238 10.1272L16.891 7.1419L22.4494 10.5472L22.1386 12.6021L23.409 13.3704C23.5443 13.4522 23.5095 13.6584 23.355 13.6907L22.4058 13.8893L23.1146 14.3179C23.2498 14.3997 23.215 14.6059 23.0605 14.6383L21.7905 14.9039L21.4709 17.0174L15.7085 19.7192L16.9919 22.5567H15.6332L14.5875 20.2448L14.0118 20.5147L14.9354 22.5567H13.5767L12.8908 21.0403L10.6043 22.1123L8.72108 18.0516C7.01094 17.7344 5.1493 16.8945 2.95093 15.0705C2.61958 14.7956 2.28058 14.4983 1.93329 14.1771L6.01737 12.2488C5.56519 10.2734 6.04988 8.1619 7.39267 6.57173ZM9.32133 10.6889L8.66326 10.9996L7.16841 11.7005C6.93284 10.3524 7.2269 8.94791 8.0131 7.79992L9.32133 10.6889ZM9.18751 12.126L4.1979 14.4818C4.46916 14.6937 4.73331 14.8883 4.99078 15.0669C5.02111 15.0769 5.05104 15.0895 5.08034 15.1046C6.90979 16.0499 8.794 15.3946 9.84739 14.2322C10.0774 13.9783 10.4685 13.96 10.721 14.1913C10.9735 14.4226 10.9917 14.8159 10.7616 15.0697C10.1066 15.7926 9.194 16.3724 8.15474 16.6407C9.4332 17.0119 10.6121 17.0247 11.8371 16.8919C13.3866 16.7239 14.6086 15.2092 14.5021 13.5059C14.3923 11.7501 12.6118 10.6369 11.0142 11.2695L9.18751 12.126ZM13.4129 10.1448C14.6755 10.679 15.6401 11.8865 15.7365 13.4278C15.88 15.7243 14.2449 17.8817 11.9697 18.1284C11.373 18.1931 10.7722 18.2272 10.1575 18.2063L11.2026 20.4597L20.3477 16.1718L21.1028 11.1785L16.8132 8.55053L13.4129 10.1448Z",
    fill: "#00322E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17366_221862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.3403,
    height: 17.1145,
    fill: "white",
    transform: "translate(1.91162 5.44238)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLbLogoSmall);
export default __webpack_public_path__ + "static/media/lb-logo-small.9cf758ea7ccb448e1c45b7ec44d77a3c.svg";
export { ForwardRef as ReactComponent };